import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthCustomerGuard implements CanActivate, CanActivateChild {
  constructor(
    private _config: ConfigurationService,
    private _authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._accessIsAllowed(route, state);
  }
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._accessIsAllowed(route, state);
  }

  private _accessIsAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isAllowed: boolean;

    const isCustomer =
      this._config &&
      this._config.configuration.user &&
      this._config.configuration.user.isCustomer;

    if (isCustomer) {
      isAllowed = true;
    } else {
      this._authService.redirectToAuthPage();
      isAllowed = false;
    }

    return isAllowed;
  }
}
